import SVG from "../../../Components/SVG";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";

const displayOptionalValue = (value) =>
  value === null ||
  value === undefined ||
  String(value).trim() === "" ||
  String(value).trim() === "-"
    ? "ندارد"
    : value;

export default function TransactionsGridCard({
  uuid,
  transactionType,
  paymentType,
  requestDate,
  volume,
  accountID,
  doneDate,
  status,
}) {
  const statusProps = {
    done: { text: "تکمیل شده", color: "green" },
    stall: { text: "در انتظار", color: "yellow" },
    failed: { text: "رد شده", color: "red" },
  }[status];

  return (
    <article className="w-full rounded-2xl p-2.5 flex flex-col gap-3 bg-gradient-to-br from-white/10 to-white/5 border border-white/10">
      <div className="w-full flex items-start justify-between gap-2.5">
        <div className="flex items-end justify-center gap-2.5 text-zi-text-light dark:text-zi-text-dark">
          <SVG
            name={transactionType === "deposit" ? "deposit" : "withdraw"}
            classname={transactionType === "withdraw" ? "stroke-[#D71F1F]" : ""}
          />
          <span className="text-sm">{transactionType === "deposit" ? "واریز" : "برداشت"}</span>
        </div>
        {statusProps && (
          <StatusColorful
            text={statusProps.text}
            className="w-fit"
            color={statusProps.color}
            containerClassName="!w-fit"
          />
        )}
      </div>
      <div className="w-full flex items-center justify-between gap-2.5">
        <div className="flex flex-col gap-0 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            روش پرداخت
          </span>
          <span className="text-sm text-zi-text-light dark:text-zi-text-dark">
            {paymentType}
          </span>
        </div>
        <div className="flex flex-col gap-0 items-end">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            مبلغ
          </span>
          <span className="text-sm text-zi-text-light dark:text-zi-text-dark">
            {volume}
          </span>
        </div>
      </div>
      <div className="w-full flex items-center justify-between gap-2.5">
        <div className="flex flex-col gap-0 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            تاریخ درخواست
          </span>
          <span className="text-xs text-zi-text-light/75 dark:text-zi-text-dark/75 [direction:ltr]">
            {requestDate}
          </span>
        </div>
        <div className="flex flex-col gap-0 items-end">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            تاریخ تکمیل
          </span>
          <span className="text-xs text-zi-text-light/75 dark:text-zi-text-dark/75 [direction:ltr]">
            {displayOptionalValue(doneDate)}
          </span>
        </div>
      </div>
      <div className="w-full flex items-center justify-between gap-2.5">
        <div className="flex flex-col gap-0 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            کد تراکنش
          </span>
          <span className="text-xs text-zi-text-light/75 dark:text-zi-text-dark/75 [direction:ltr]">
            {uuid}
          </span>
        </div>
        <div className="flex flex-col gap-0 items-end">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            کد حساب
          </span>
          <span className="text-xs text-zi-text-light/75 dark:text-zi-text-dark/75 [direction:ltr]">
            {displayOptionalValue(accountID)}
          </span>
        </div>
      </div>
    </article>
  );
}
